const Product = ({ product, onAddToCart, onProductClick }) => {
  return (
    <div
      className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-xl transition duration-300 cursor-pointer border border-gray-100 hover:border-gray-200"
      onClick={() => onProductClick(product)}
    >
      <img
        src={`../myNewAPI/${product.prod_img}`}
        alt={product.prod_name}
        className="w-full h-48 sm:h-64 object-cover bg-gray-100 transition duration-300 hover:scale-105"
      />
      <div className="p-6">
        <span className="text-xs font-semibold text-red-600 uppercase tracking-wider mb-2 block">
          {product.cat_title}
        </span>
        <h4 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
          {product.prod_name}
        </h4>
        <p className="text-3xl font-black text-gray-900 mb-4">
          PKR{" "}
          {product.prod_price
            ? new Intl.NumberFormat("en-IN").format(product.prod_price)
            : 0}
        </p>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onAddToCart(product);
          }}
          className="w-full bg-red-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-red-700 hover:shadow-lg transition duration-200 transform hover:scale-105"
        >
          Add to Cart
        </button>
      </div>
    </div>
  );
};
export default Product;
